import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FrequencyWarningSnippet = _resolveComponent("FrequencyWarningSnippet")!
  const _component_ProjectContainerComponent = _resolveComponent("ProjectContainerComponent")!
  const _component_GiftArrayComponent = _resolveComponent("GiftArrayComponent")!
  const _component_ValidatedInput = _resolveComponent("ValidatedInput")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.showFrequencyWarning && !_ctx.renderStore.builderMode)
      ? (_openBlock(), _createBlock(_component_FrequencyWarningSnippet, {
          key: 0,
          frequency: _ctx.renderStore.gift.frequency,
          class: "rd-mb-3"
        }, null, 8, ["frequency"]))
      : _createCommentVNode("", true),
    (_ctx.showProjects)
      ? (_openBlock(), _createBlock(_component_ProjectContainerComponent, {
          key: 1,
          component: _ctx.component,
          useSmartGiftArray: _ctx.useSmartGiftArray
        }, null, 8, ["component", "useSmartGiftArray"]))
      : _createCommentVNode("", true),
    (_ctx.showGiftArray)
      ? (_openBlock(), _createBlock(_component_GiftArrayComponent, {
          key: 2,
          component: _ctx.component,
          useSmartGiftArray: _ctx.useSmartGiftArray
        }, null, 8, ["component", "useSmartGiftArray"]))
      : _createCommentVNode("", true),
    _createVNode(_component_ValidatedInput, {
      id: _ctx.component.id,
      displayName: 'Gift Amount',
      value: _ctx.renderStore.amount,
      isRequired: true,
      isStepError: true,
      name: "Amount"
    }, {
      input: _withCtx(() => [
        _createElementVNode("span", {
          class: _normalizeClass(["rd-block rd-font-semibold rd-tracking-wide rd-leading-none rd-mt-3 rd-text-center rd-uppercase gift-total", { 'rd-small-caps': _ctx.renderStore.builderMode }])
        }, "Total: " + _toDisplayString(_ctx.formattedTotal), 3)
      ]),
      _: 1
    }, 8, ["id", "value"])
  ], 64))
}